/**
 * Códigos de erro do "Ocupado sem identificação" (CONTRACT.md) → frase pt-BR.
 *
 * Catálogo próprio (e não o `message` do backend) porque a mesma recusa chega de
 * endpoints diferentes (criar, lote, edição unitária, registro de ponto) e a frase
 * precisa ser estável — e dizer o que fazer. Algumas mensagens do BE são escritas
 * para o app do médico ("não está mais disponível para você"); aqui elas falam com
 * o escalista.
 *
 * Arquivo sem imports de propósito: `apiError.ts` o consulta em
 * `getApiErrorMessage` e `coverageErrors.ts` depende de `apiError.ts`.
 */
export const COVERAGE_ERROR_MESSAGES = {
  PLACEHOLDER_DOCTOR_BLOCKED:
    'Este médico não pode ser usado como coringa. Use a opção Ocupado sem identificação.',
  COVERAGE_BLOCKED_ANTECIPE:
    'Este plantão tem Antecipe solicitado ou pago e não pode ficar sem identificação. Trate o Antecipe com o financeiro antes de mudar a cobertura.',
  COVERAGE_BLOCKED_CHECKIN:
    'Este plantão já tem check-in registrado e não pode ficar sem identificação.',
  COVERAGE_BLOCKED_POST_STATION_APPROVED:
    'Este plantão tem avaliação de pós-plantão aprovada e não pode ficar sem identificação.',
  COVERAGE_NOT_ALLOWED_IN_SCHEDULE:
    'Esta escala não permite plantão ocupado sem identificação. Ative a opção na configuração da escala.',
  COVERAGE_FEATURE_DISABLED:
    'O plantão ocupado sem identificação ainda não está disponível. Tente novamente mais tarde.',
  COVERAGE_NOT_SUPPORTED_IN_BULK_ALL:
    'Use a alocação por escala para marcar Ocupado sem identificação.',
  COVERAGE_RESPONSIBLE_INVALID: 'Selecione um responsável pela cobertura ativo desta unidade.',
  COVERAGE_RESPONSIBLE_DUPLICATE_NAME: 'Já existe um responsável com esse nome nesta unidade.',
  COVERAGE_RESPONSIBLE_REQUIRED: 'Selecione o responsável pela cobertura.',
  COVERAGE_RESPONSIBLE_NOT_FOUND:
    'Responsável pela cobertura não encontrado nesta unidade. Atualize a lista e tente novamente.',
  COVERAGE_RESPONSIBLE_NAME_REQUIRED: 'Informe o nome do responsável pela cobertura.',
  COVERAGE_CONFLICTING_DOCTOR:
    'Não informe médico ao escolher Ocupado sem identificação ou vaga aberta.',
  COVERAGE_DOCTOR_REQUIRED: 'Informe o médico do plantão.',
  COVERAGE_MIXED_OPERATION_REASONS:
    'Não misture Ocupado sem identificação com outras alterações no mesmo envio. Faça a marcação separadamente.',
  COVERAGE_UNIDENTIFIED_STATION:
    'Este plantão está ocupado sem identificação. Identifique o médico antes de registrar ponto.',
  DS_ATTENDANCE_CONCILIATION_UNIDENTIFIED_COVERAGE:
    'A linha da folha não pode ser vinculada a um plantão ocupado sem identificação. Identifique o médico do plantão antes de conciliar.',
  EXCEPTION_UNIDENTIFIED_COVERAGE_NOT_ALLOWED:
    'Plantão ocupado sem identificação não aceita excepcionalidade de valor, horário ou pagamento À vista. Identifique o médico antes de solicitar.',
  HANDOVER_DESTINY_WITHOUT_USER:
    'Não foi possível aceitar a troca: seu cadastro não tem um usuário vinculado. Procure a coordenação da escala.'
} as const

export type CoverageErrorCode = keyof typeof COVERAGE_ERROR_MESSAGES

/** Frase do catálogo para o código, ou `null` quando não é um código de cobertura. */
export function coverageMessageForCode(code: unknown): string | null {
  if (typeof code !== 'string') return null
  return Object.prototype.hasOwnProperty.call(COVERAGE_ERROR_MESSAGES, code)
    ? COVERAGE_ERROR_MESSAGES[code as CoverageErrorCode]
    : null
}
